import '../styles/version-bar.css';

// The bar that stays on top of a plan version while its content scrolls.
//
// WHY PINNED. A plan is the longest text in the panel, and its actions used to
// live under the editor and the scope: to save, somebody scrolled past the
// whole document; to approve, past it again. What is being acted on (which
// version, in which state, at which revision) and what can be done with it now
// travel together, in sight.
//
// It shows and it triggers; it decides nothing. Which actions exist for which
// state, and whether each one is allowed, is the screen's call — the bar only
// gets them as children.

export default function VersionBar({ title, number, stateLabel, tone = 'neutral', revision, dirty, children }) {
    return (
        <div className={`version-bar version-bar--${tone}`} role="region" aria-label={`Versión ${number} del plan`}>
            <div className="version-bar__identity">
                <span className="version-bar__title" title={title}>{title}</span>
                <span className="version-bar__facts">
                    <span className={`version-bar__version version-bar__version--${tone}`}>
                        v{number} · {stateLabel}
                    </span>
                    <span className="version-bar__revision">Revisión {revision}</span>
                    {/* Said here and not only next to the editor: this bar is what
                        stays in sight, and an unsaved change is the one thing
                        somebody must not lose track of while scrolling. */}
                    {dirty && <span className="version-bar__dirty">Cambios sin guardar</span>}
                </span>
            </div>

            {children && <div className="version-bar__actions">{children}</div>}
        </div>
    );
}

// One action. The label is always in the markup: on a narrow screen it is
// hidden visually and still read, so the icon never has to carry the meaning
// alone.
export function BarAction({ icon, label, onClick, disabled, primary = false, title }) {
    return (
        <button
            type="button"
            className={`version-bar__action${primary ? ' version-bar__action--primary' : ''}`}
            onClick={onClick}
            disabled={disabled}
            title={title ?? label}
        >
            {icon}
            <span className="version-bar__label">{label}</span>
        </button>
    );
}
